import { render, staticRenderFns } from "./personCenter.vue?vue&type=template&id=adfa4d0e&scoped=true&"
import script from "./personCenter.vue?vue&type=script&lang=js&"
export * from "./personCenter.vue?vue&type=script&lang=js&"
import style0 from "./personCenter.vue?vue&type=style&index=0&id=adfa4d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfa4d0e",
  null
  
)

export default component.exports